import { ParticipantType } from "../enums";
import { IVariable } from "../types";

export class WorkflowStatus {
    public activeActivities: ActiveActivity[];
    public variables: IVariable[];
    public isWfEnded: boolean;

    constructor(activeActivities: ActiveActivity[], variables: IVariable[], isWfEnded: boolean) {
        this.activeActivities = activeActivities;
        this.variables = variables;
        this.isWfEnded = isWfEnded;
    }
}

/** Typ reprezentující aktivní aktivitu. Používá se při zobrazení stavu WF. */
export type ActiveActivity = {
    parentActivityId: string;
    activityId: string;
    order: number;
    activatedInputTransitionIds: string[];
    /** Zdědění "aktivní" hráči */
    activeParticipants: ActualizedParticipant[];
};

/** Typ reprezentující aktivního hráče. Pro jednoduchost uvádíme jen tyto základní vlsatnosti. Pokud bude v budoucnu potřeba, může být nahrazen abstraktní třídou Participant.*/
export type ActualizedParticipant = {
    type: ParticipantType;
    id: string;
    name: string;
};
